const cart = document.querySelector(".woocommerce-cart-form");
const wc = document.querySelector(".woocommerce");

// Define deleteNotices outside of the event listeners
const deleteNotices = function () {
	const notices = document.querySelectorAll('.remove-after-cart-update');
	notices.forEach(notice => {
	  	notice.remove();
	});
};

window.addEventListener('DOMContentLoaded', () => {
	if (document.body.classList.contains('woocommerce-cart')) {
		const freeMiniBtns = document.querySelectorAll('.free-mini-btn');
		const btns = Array.from(freeMiniBtns);

		btns.forEach(btn => {
			btn.addEventListener('click', (e) => {
				$(document).trigger('updated_cart_totals');
			});
		});
	}
});

let yithModalsToHide = {};

// drl-832
if (document.body.classList.contains('woocommerce-cart')) {
	$(document.body).on('updated_wc_div updated_cart_totals', function (e, obj) {
		// @TODO: this is hardcoded, should be set via PHP (and retrieved via an option). Also see Cart.php
		let rule_free_mini_id     = 307581;

		let value = sessionStorage.getItem('modals_to_hide');
		rule_free_mini_id = rule_free_mini_id.toString();

		if ( value === null ) {
			value = []
		} else {
			value = JSON.parse(value);
		}

		let totalElement = document.querySelector('.cart-subtotal .woocommerce-Price-amount bdi')

		if ( !totalElement ) {
			sessionStorage.removeItem('modals_to_hide');
			return;
		}

		let total = totalElement.innerText.replace('€', '').replace(',', '.');

		if (total < 45) {
			sessionStorage.removeItem('modals_to_hide');
		} else if (total < 55) {

			if ( value.includes( rule_free_mini_id ) ) {
				value = value.filter( item => item !== rule_free_mini_id )
			}

			sessionStorage.setItem('modals_to_hide', JSON.stringify( value ));
		}

		updateProgressBars();
	})

	// Add event listerner for WooCommerce events
	$(document.body).on('added_to_cart removed_from_cart wc_fragments_refreshed updated_wc_div updated_cart_totals', () => {
		setTimeout(() => {
			// Update progress bars
			const progressbars = $('.progress-bar-wrapper__bar');
			progressbars.each(function() {
				$(this).css('width', $(this).attr('data-width') + '%');
			});

			// Close coupon toggle
			const couponCheck = document.querySelector('.coupon-toggle > details');
			if(couponCheck.getAttribute('open') !== null) {
				couponCheck.removeAttribute('open');
			} 
		}, 500);
	});

	// Temp disabled
	// // Prevent Yith modals from showing up
	// const preventModalsPopup = function () {
	// 	document.querySelectorAll( '.ywdpd_popup.cart' ).forEach( modal => {
	// 		const wrapper = modal.querySelector( '.ywdpd_popup_wrapper' )
	// 		const ruleId = wrapper.getAttribute( 'data-rule_id' )
	// 		let value = sessionStorage.getItem('modals_to_hide')
	// 			value = JSON.parse(value)

	// 		if ( value === null ) {
	// 			value = []
	// 		}

	// 		hideModalsPopups(modal, value, ruleId);

	// 		modal.querySelectorAll('.ywdpd_footer a').forEach( anchor => {
	// 			anchor.addEventListener('click', e => {
	// 				e.preventDefault();

	// 				let value = sessionStorage.getItem('modals_to_hide')
	// 				value = JSON.parse(value)

	// 				if ( value === null ) {
	// 					value = []
	// 				}

	// 				if ( !value.includes( ruleId ) ) {
	// 					value.push( ruleId )
	// 					sessionStorage.setItem('modals_to_hide', JSON.stringify( value ))
	// 				}
	// 			})
	// 		})

	// 		modal.querySelectorAll('.single_add_to_cart_button').forEach( anchor => {
	// 			anchor.addEventListener('click', e => {
	// 				let value = sessionStorage.getItem('modals_to_hide')
	// 				value = JSON.parse(value)

	// 				if ( value === null ) {
	// 					value = []
	// 				}

	// 				if ( !value.includes( ruleId ) ) {
	// 					value.push( ruleId )
	// 					sessionStorage.setItem('modals_to_hide', JSON.stringify( value ))

	// 					setTimeout(() => {
	// 						hideModalsPopups(modal, value, ruleId);
	// 					}, 1 );
	// 				}
	// 			})
	// 		})
	// 	})
	// }

	// const hideModalsPopups = function (modal, value, ruleId ) {
	// 	if ( value !== null && value.includes( ruleId ) ) {
	// 		modal.style.display = 'none'
	// 		modal.style.visibility = 'hidden'

	// 		// Trigger click on close button top simulate that the user closes this popup.
	// 		let clickEventModal = new MouseEvent('click', {
	// 			bubbles: true,
	// 			cancelable: true,
	// 			view: window
	// 		});
	// 		modal.querySelector('.ywdpd_close').dispatchEvent(clickEventModal);
	// 	}
	// }

	// Listen for DOM changes and prevent Yith modals from showing up
	// Temp disabled
	// document.addEventListener( 'DOMContentLoaded', preventModalsPopup )

	// Start mutation observer to prevent Yith modals from showing up
	const observer = new MutationObserver( mutations => {
		mutations.forEach( mutation => {
			if ( mutation.type === 'childList' ) {
				const addedNodes = Array.from( mutation.addedNodes )
				const isPopupAdded = addedNodes.some( node => node.matches && node.matches( '.ywdpd_popup.cart' ) )

				if ( isPopupAdded ) {
					// Remove duplicate popups.
					let popupArray = [];
					let popups = document.querySelectorAll( '.ywdpd_popup.cart .ywdpd_popup_wrapper' );
					popups.forEach( popup => {
						const ruleId = popup.getAttribute('data-rule_id');
						if ( !popupArray.includes( ruleId ) ) {
							popupArray.push( ruleId );
						} else {
							popup.parentNode.remove();
						}
					})

					// Teamp disabled
					// preventModalsPopup()
				}
			}
		})
	})

	// Start observing the body
	observer.observe( document.body, {
		childList: true
	})

	// Custom handling of coupon submit (copied from checkout.js of woocommerce, because in our checkout the coupon form is inside the checkout form)
    $('button[form="checkout_apply_coupon"]').on('click', function(e) {
        const $wrapper = $('.coupon-input');
        let data = {
            security:		wc_cart_params.apply_coupon_nonce,
            coupon_code:	$(this).parent().find('#coupon_code').val()
        };

        // $( '.woocommerce-error, .woocommerce-message, .wc-block-components-notice-banner' ).remove();

        $.ajax({
            type:		'POST',
            url:		wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'apply_coupon' ),
            data:		data,
            success:	function( code ) {
                if ( code ) {
                    $wrapper.before( code );
                    //$wrapper.slideUp();

                    $( document.body ).trigger( 'applied_coupon', [ data.coupon_code ] );
					$( '.woocommerce-cart-form' ).find( ':input[name="update_cart"]' ).prop( 'disabled', false ).attr( 'aria-disabled', false ).trigger( 'click' );
                }

				$('.coupon-spinner-loader').css('display', 'none');
            },
            dataType: 'html'
        });
    });

    // Add spinners to buttons
    $('.coupon-input button.button').click(function(e) {
        e.preventDefault();
        $('.coupon-spinner-loader').css('display', 'block');
    });

	function drlQuantityUpdateButtons(element) {
		let drlQuantityUpdateSend = true;

		if (drlQuantityUpdateSend) {
			drlQuantityUpdateSend = false;

			const wrap = $(element.closest(".cart_item"));
			const input = wrap.find(".qty");
			const key = wrap.data("key");
			let number = parseInt(input.val());
			const type = element.getAttribute('data-type');
			let direction = type === "minus" ? "down" : "up";

			if (type === "minus") {
				number--;
			} else {
				number++;
			}

			if (number < 1) {
				number = 1;
			}

			input.val(number);

			const data = {
				action: "mini_cart_qty_update",
				key: key,
				number: number,
				security: js_data.mini_cart.nonce
			};

			const cartItem = $('[data-key="'+key+'"]');

			// cartItem.addClass('loading');

			$.post(js_data.ajax_url, data, (res) => {
				$( '.woocommerce-cart-form' ).find( ':input[name="update_cart"]' ).prop( 'disabled', false ).attr( 'aria-disabled', false ).trigger( 'click' );

				// Remove loading class
				// cartItem.removeClass('loading');
				// Update drlQuantityUpdateSend
				drlQuantityUpdateSend = true;
				// updateProgressBars(res['data']);
			});
		}
	}

    function updateProgressBars(data) {
        const progressbars = document.querySelectorAll('.progress-bar-wrapper__bar');
		const progressbarPoints = document.querySelectorAll('.progress-bar-wrapper__point');
        let oldValues = [];
        let newValues = [];

        // Get the old values
        progressbars.forEach(bar => {
            oldValues.push(parseInt(bar.getAttribute('data-width')));
        });

        if (data !== undefined) {
            const updatedValues = data.progressbar.bars;
            const updatedTargetPriceHTML = data.progressbar.spend_html;
            const updatedTargetText = data.progressbar.text;
            const targetPrice = document.getElementById('target-price');
            const targetText = document.getElementById('target-text');

            // Determine the direction of change
            const direction = updatedValues.map((value, index) => {
                return value.progressbar_percentage - oldValues[index] > 0 ? 1 : -1;
            });

			// Get the highest price among the progress bars
			const highestPrice = Math.max(...data.progressbar.bars.map(bar => bar.price));

			// Check if the total is higher than the highest progress bar price
			if (data.total > highestPrice) {
				 document.querySelector('.under').style.display = 'none';
				 document.querySelector('.over').style.display = 'block';
			} else {
				 document.querySelector('.under').style.display = 'block';
				 document.querySelector('.over').style.display = 'none';
				 targetPrice.innerHTML = updatedTargetPriceHTML;
				 targetText.innerHTML = updatedTargetText;
			}

            // Update the progress bars
            progressbars.forEach((bar, index) => {
                const newValue = updatedValues[index].progressbar_percentage;
                bar.style.width = newValue + '%';
                bar.setAttribute('data-width', newValue);

                // for animation
                // const animationDelay = index * 450; // Adjust the delay time as needed

                // setTimeout(() => {
                //     bar.style.width = newValue + '%';
                //     bar.setAttribute('data-width', newValue);
                // }, direction[0] === 1 ? animationDelay : (progressbars.length - index - 1) * 450); // Reverse order for decreasing

                newValues.push(newValue);
            });

			progressbarPoints.forEach((point, index) => {
                point.classList.remove('active-point');

                const newValue = updatedValues[index].progressbar_percentage;
                if (newValue !== 100 && newValue !== 0) {
                    point.classList.add('active-point');
                }
            });
        } else {
            // Reset the progress bars
            progressbars.forEach(bar => {
                bar.style.width = bar.getAttribute('data-width') + '%';
                bar.style.transition = '';
            });
        }
    }

	document.body.addEventListener('click', function(event) {
		if (event.target.classList.contains('drl-item-quantity-btn')) {
			event.preventDefault();
			drlQuantityUpdateButtons(event.target);
		}
	});

	updateProgressBars();
}

$(document).on('updated_cart_totals', function () {
	deleteNotices();
});

// Make checkout-button sticky
const checkoutBtn = document.querySelector('.checkout-button');
const fixedCheckoutBtn = document.querySelector('.sticky-checkout-btn');
let isSticky = false;

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function toggleStickyClass() {
	if( checkoutBtn === null ) {
		return
	}

	if (window.innerWidth < 450) {
		if (isInViewport(checkoutBtn)) {
			fixedCheckoutBtn.classList.remove('show');
		} else {
			fixedCheckoutBtn.classList.add('show');
		}
	}
}

document.addEventListener('scroll', toggleStickyClass, { passive: true });
